module.exports = __webpack_public_path__ + "img/solid_II 0.36f79701.svg";